import { render } from "./AccountSettingView.vue?vue&type=template&id=2a561d3c&lang=html"
import script from "./AccountSettingView.vue?vue&type=script&lang=js"
export * from "./AccountSettingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__